import { twMerge } from "tailwind-merge";
import styles from "./spinner.module.css";

interface SpinnerProps {
  classNames?: string;
  wrapperClassNames?: string;
}

/**
 * @deprecated Use Spinner from @sellar-io/components for new loading states.
 */
export function SpinnerLegacy({
  classNames = "",
  wrapperClassNames = "",
}: SpinnerProps) {
  return (
    <div className={twMerge(styles.spinnerContainer, wrapperClassNames)}>
      <div className={twMerge(styles.spinner, classNames)}>
        <svg
          className={styles.svg}
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="length"
            fill="none"
            strokeWidth="8"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="28"
          />
        </svg>
        <svg
          className={styles.svg}
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            fill="none"
            strokeWidth="8"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="28"
          />
        </svg>
        <svg
          className={styles.svg}
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            fill="none"
            strokeWidth="8"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="28"
          />
        </svg>
        <svg
          className={styles.svg}
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            fill="none"
            strokeWidth="8"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="28"
          />
        </svg>
      </div>
    </div>
  );
}
